import { render, staticRenderFns } from "./addEditCategory.vue?vue&type=template&id=8a6e8d2a&"
import script from "./addEditCategory.vue?vue&type=script&lang=js&"
export * from "./addEditCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports